import React, { useState, useEffect } from 'react';

const Admin = () => {
    const [hashtag, setHashtag] = useState('');
    const [goldStatus, setGoldStatus] = useState('');
    const [postText, setPostText] = useState('');
    const [submitStatus, setSubmitStatus] = useState('');
    const userLevel = Number(localStorage.getItem("fw_user_lvl"));

    useEffect(() => {
        if (userLevel <= 1) {
            window.location.href = '/';
        }
    }, []);

    const handleTrendSubmit = async () => {
        const res = await fetch('https://api.fantasyworldtrpg.cz/echo/set_gold.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ hashtag })
        });

        const data = await res.json();
        setGoldStatus(data.message || 'Změna proběhla');
    };

    const handleEchoPost = async () => {
        const res = await fetch('https://api.fantasyworldtrpg.cz/echo/admin_post.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                uid: "1", // účet Echo
                text: postText,
                tags: [],
                image: '',
                filter: '',
                frame: '',
                feeling: ''
            })
        });

        const data = await res.json();
        setSubmitStatus(data.success ? 'Příspěvek odeslán!' : data.message);
    };

    return (
        <div className="container my-5 py-5">
            <h3>Admin Panel</h3>

            <div className="border rounded p-3 my-4">
                <h5>🎯 Změna Gold trendu</h5>
                <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="Zadej nový gold hashtag (nebo nech prázdné)"
                    value={hashtag}
                    onChange={(e) => setHashtag(e.target.value)}
                />
                <button className="btn btn-warning" onClick={handleTrendSubmit}>Uložit</button>
                {goldStatus && <div className="mt-2 text-success">{goldStatus}</div>}
            </div>

            <div className="border rounded p-3 my-4">
                <h5>🗯️ Přidat příspěvek za Echo</h5>
                <textarea
                    className="form-control mb-2"
                    rows="3"
                    placeholder="Text příspěvku..."
                    value={postText}
                    onChange={(e) => setPostText(e.target.value)}
                />
                <button className="btn btn-danger" onClick={handleEchoPost}>Odeslat</button>
                {submitStatus && <div className="mt-2 text-success">{submitStatus}</div>}
            </div>
        </div>
    );
};

export default Admin;
